<h2 class="header">Eieform</h2>

<div class="container">
    <ul>
        @for (option of filterForm(); track $index) {
        <li class="check-box" (click)="toggleSelected(option().value())">
            <div class="checkbox-icon" [class.selected]="option.selected().value()"></div>
            <label> {{ option.label().value() }} </label>
        </li>
        }
    </ul>
</div>